import { createContext } from "react";
import useReports from "../hooks/data/useReports";

export interface IReportsContext extends ReturnType<typeof useReports> {

};

const ReportsContext = createContext<IReportsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ReportsContext